/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// tanstack query
import { useMutation } from '@tanstack/react-query';

// api
import { apiClient } from '@lib/api-client';

// types
import { TMutationConfig } from '@lib/react-query';

/* -------------------------------------------------------------------------- */
/*                                     Type                                   */
/* -------------------------------------------------------------------------- */
type TUseDeleteMultipleProductionsOptions = {
	mutationConfig?: TMutationConfig<
		typeof deleteMultipleProductions
	>;
};

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const deleteMultipleProductions = ({
	data,
}: {
	data: {
		ids: string[];
	};
}): Promise<string[]> => {
	return apiClient.delete(`/productions`, { data });
};

/* -------------------------------------------------------------------------- */
/*                                     Hooks                                  */
/* -------------------------------------------------------------------------- */
export const useDeleteMultipleProductions = ({
	mutationConfig,
}: TUseDeleteMultipleProductionsOptions = {}) => {
	return useMutation({
		...mutationConfig,
		mutationFn: deleteMultipleProductions,
	});
};
